class h {
  constructor() {
    this.events = {};
  }
  on(s, t) {
    this.events[s] || (this.events[s] = []), this.events[s].push(t);
  }
  emit(s, ...t) {
    this.events[s] && this.events[s].forEach((i) => {
      i(...t);
    });
  }
  off(s, t) {
    this.events[s] && (this.events[s] = this.events[s].filter((i) => i !== t));
  }
}
const n = new h();
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-waterfall2/dist/bus.es.js
// module id = null
// module chunks = 